<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NbIKzX/tc-custom/9780795324857.jpg?1718282658642" alt="This image is the cover for the book 2061, Space Odyssey Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">2061, Space Odyssey Series
      </h1>
      <p class="bookDescription body article font2">
        <b>This <i>New York Times</i>–bestselling chapter in the Hugo Award–winning Space Odyssey series is “intriguing and satisfying . . . the all-round best Odyssey so far” (<i>Kirkus Reviews</i>).</b><br/>  <br/> The third book in Clarke’s beloved Space Odyssey continues the story of Heywood Floyd, survivor of two previous encounters with the mysterious monoliths and the alien intelligences behind them. Floyd is chosen as one of a handful of celebrity guests to witness the first manned touchdown on the surface of Halley’s Comet on the privately-owned spaceship <i>Universe</i>.<br/>  <br/> But on Jupiter’s moon Europa, scientists have spotted the sudden appearance of a single diamond the size of a mountain—a fragment of Jupiter’s core. When the spaceship <i>Galaxy</i> is hijacked and forced to crash into Europa’s ocean, the <i>Universe</i> is diverted from its original mission to rescue the crew.<br/>  <br/> Now Heywood Floyd must once again survive an encounter with HAL, David Bowman, and the mysterious monolith-building race with its own inscrutable agenda to shape the destiny of the human race.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Arthur C. Clarke
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b9b2574